import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const tok = localStorage.getItem("hs_token");
  if (tok) cfg.headers.Authorization = `Bearer ${tok}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("hs_token");
    }
    return Promise.reject(err);
  }
);

// Public reads
export const fetchServices = () => api.get("/services").then((r) => r.data);
export const fetchTestimonials = () => api.get("/testimonials").then((r) => r.data);
export const fetchGallery = () => api.get("/gallery").then((r) => r.data);
export const fetchFaq = () => api.get("/faq").then((r) => r.data);

// Auth
export const loginApi = (username, password) =>
  api.post("/auth/login", { username, password }).then((r) => r.data);
export const meApi = () => api.get("/auth/me").then((r) => r.data);

// Admin CRUD
export const adminCrud = (path) => ({
  list: () => api.get(`/${path}`).then((r) => r.data),
  create: (data) => api.post(`/${path}`, data).then((r) => r.data),
  update: (id, data) => api.patch(`/${path}/${id}`, data).then((r) => r.data),
  remove: (id) => api.delete(`/${path}/${id}`).then((r) => r.data),
});

// Upload
export const uploadImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};

// Helper to resolve relative /api/uploads/... paths
export const resolveUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
};

export default api;
